import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46c65980"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column gap-4" }
const _hoisted_2 = { class: "dialog-select-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  INotification,
  NotificationStatus,
} from '@/store/modules/notifications/models/notification.interface';
import { useNotifications } from '@/store/modules/notifications/useNotifications';
import { useWallet } from '@/store/modules/wallet/useWallet';
import { WALLET_LIST } from '@/helpers/connectors/wallets/connectors.helper';
import NoWalletModal from '@/views/layout/wallet/NoWalletModal.vue';
import Icon from '@/components/icon/Icon.vue';
import { HardwareWalletIsNotSupportedError } from '@/sdk/errors';
import { ENABLE_FAKE_CARDANO_NETWORK } from '@/helpers/fakeCardanoNetwork';
import { CONNECTORS_LIST } from '@/utils/auth';
import { SELECTED_NETWORK_NAME } from '@/helpers/networkParams.helper';
import UserAgreement from '@/views/layout/user-agreement/UserAgreement.vue';
import { useLocalStorage } from '@/composables/useLocalStorage';


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletConnect',
  props: {
    buttonClass: null,
    isHeaderButton: { type: Boolean },
    buttonIcon: { type: Boolean }
  },
  emits: ["onSelectWallet"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onSelectWallet', id: string): void;
}), expose: any, slots: any, attrs: any }) {

const SUPPORT_HARDWARE_WALLET_NOTIFICATION_ID = 'support-hardware-wallet';




const { t } = useI18n();

const { addNotification } = useNotifications();
const { login } = useWallet();
const { getItem } = useLocalStorage();

const isConnectorListDialog = ref(false);
const isDisabledConnectorList = ref(!getItem('agreement'));

const isNoWalletDialog = ref(false);
const walletConnector = ref();
const walletListWithoutNotSupported = computed(() => {
  return WALLET_LIST.filter(wallet => {
    if (wallet && wallet.id && CONNECTORS_LIST[wallet.id]?.disconnectNetworks) {
      if (CONNECTORS_LIST[wallet.id]?.disconnectNetworks.includes(SELECTED_NETWORK_NAME)) {
        return false;
      }
    }
    return wallet;
  });
});

const getSupportHardwareWalletsNotificationOptions = (
  status: NotificationStatus,
): INotification => {
  const MESSAGE = {
    inProgress:
      'Please, sign a test message to check your wallet (nothing will be charged from your wallet)',
    success:
      'Please, sign a test message to check your wallet (nothing will be charged from your wallet)',
    error: 'Sorry, hardware wallets are not supported yet',
  };
  return {
    id: SUPPORT_HARDWARE_WALLET_NOTIFICATION_ID,
    status: status,
    content: MESSAGE[status],
  };
};

const onShowConnectorList = () => {
  isConnectorListDialog.value = true;
};
const onHideConnectorList = () => {
  isConnectorListDialog.value = false;
};
const onSelect = async connector => {
  emits('onSelectWallet', connector.id);
  onHideConnectorList();

  if (ENABLE_FAKE_CARDANO_NETWORK) {
    addNotification(getSupportHardwareWalletsNotificationOptions('inProgress'));
  }

  try {
    await login(connector.id);

    if (ENABLE_FAKE_CARDANO_NETWORK) {
      addNotification(getSupportHardwareWalletsNotificationOptions('success'));
    }
  } catch (error) {
    if (error instanceof HardwareWalletIsNotSupportedError) {
      addNotification(getSupportHardwareWalletsNotificationOptions('error'));
      isNoWalletDialog.value = false;
    } else {
      isNoWalletDialog.value = true;
      walletConnector.value = connector;
    }
  }
};

const onChangeAgreement = event => {
  isDisabledConnectorList.value = !event;
  console.log(event, isDisabledConnectorList.value);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Button, {
      class: _normalizeClass(__props.buttonClass ?? 'button-base'),
      onClick: onShowConnectorList
    }, {
      default: _withCtx(() => [
        (__props.isHeaderButton || __props.buttonIcon)
          ? (_openBlock(), _createBlock(Icon, {
              key: 0,
              name: "wallet",
              size: "20",
              class: "mr-s1 text-gray"
            }))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_unref(t)('wallet.connect')), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_Dialog, {
      modal: "",
      visible: isConnectorListDialog.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((isConnectorListDialog).value = $event)),
      header: _unref(t)('wallet.connect'),
      dismissableMask: "",
      class: "dialog-list"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(UserAgreement, {
            onOnChange: _cache[0] || (_cache[0] = ($event: any) => (onChangeAgreement($event)))
          }),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(walletListWithoutNotSupported), (connector) => {
              return (_openBlock(), _createElementBlock("div", {
                key: connector.id,
                class: _normalizeClass(["dialog-select-list-li gap-s3", isDisabledConnectorList.value ? 'p-disabled' : '']),
                role: "button",
                onClick: ($event: any) => (onSelect(connector))
              }, [
                _createElementVNode("img", {
                  src: connector.icon,
                  class: "connector-img",
                  alt: connector.name
                }, null, 8, _hoisted_4),
                _createElementVNode("div", null, _toDisplayString(connector.name), 1)
              ], 10, _hoisted_3))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"]),
    (isNoWalletDialog.value)
      ? (_openBlock(), _createBlock(NoWalletModal, {
          key: 0,
          name: walletConnector.value?.name,
          link: walletConnector.value?.link,
          modelValue: walletConnector.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((walletConnector).value = $event))
        }, null, 8, ["name", "link", "modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})